import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { ArrowBack } from '@mui/icons-material';
import {
  Button,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Stack,
  Typography,
} from '@mui/material';

import { useNotificationProject } from './useNotificationProject';

import styles from './NotificationsPanel.module.css';

type TabType = 'log' | 'manage' | 'routes';

export function NotificationsSidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { navigateTo } = useNotificationProject();

  // Determine active tab from URL
  const getActiveTab = (): TabType | null => {
    const p = location.pathname;
    if (p.includes('/notifications/log/')) return 'log';
    if (p.includes('/notifications/manage/')) return 'manage';
    if (p.includes('/notifications/routes/')) return 'routes';
    return null;
  };

  const activeTab = getActiveTab();

  return (
    <Stack justifyContent="space-between">
      <List className={styles.sidebarListContainer}>
        <ListItem className={styles.sectionTitleItem}>
          <Typography variant="h2" className={styles.sectionTitle}>
            All Notifications
          </Typography>
        </ListItem>
        <List>
          <ListItem
            selected={activeTab === 'log'}
            className={
              activeTab === 'log' ? styles.tabItemSelected : styles.tabItem
            }
          >
            <ListItemButton onClick={() => navigateTo.log()}>
              <ListItemText primary="Notification Log" />
            </ListItemButton>
          </ListItem>
        </List>
        <Divider />
        <ListItem className={styles.sectionTitleItem}>
          <Typography variant="h2" className={styles.sectionTitle}>
            Route Alerts
          </Typography>
        </ListItem>
        <List>
          <ListItem
            selected={activeTab === 'manage'}
            className={
              activeTab === 'manage' ? styles.tabItemSelected : styles.tabItem
            }
          >
            <ListItemButton onClick={() => navigateTo.manage()}>
              <ListItemText primary="Manage Alerts" />
            </ListItemButton>
          </ListItem>
          <ListItem
            selected={activeTab === 'routes'}
            className={
              activeTab === 'routes' ? styles.tabItemSelected : styles.tabItem
            }
          >
            <ListItemButton onClick={() => navigateTo.routes()}>
              <ListItemText primary="Link Routes" />
            </ListItemButton>
          </ListItem>
        </List>
      </List>
      <Button
        startIcon={<ArrowBack />}
        onClick={() => navigate('/app')}
        className={styles.backToAppButton}
      >
        Return to app
      </Button>
    </Stack>
  );
}
